// Add your custom JS here.
jQuery(document).ready(function($){


    $('.offcanvas a').click(function(){
        $('.offcanvas').offcanvas('hide');
        $('.offcanvas').removeClass('show').attr('aria-modal', false);
        $('.offcanvas-backdrop').remove();
        $('body').removeAttr( 'style' );
      
        });



    var navheight = $('#main-nav').height() + 100;

    $(window).scroll(function (){
        if( $(window).scrollTop() > navheight ){
            $('#main-nav').addClass('js-header');
            $('#page-top').removeClass('d-none');
        }else{
            $('#main-nav').removeClass('js-header');
            $('#page-top').addClass('d-none');

        }
    });



    $('#page-top > a').click(function () {
        $('body, html').animate({ scrollTop: 0 }, 500);
        return false;
     });

      

   


  });